export default __webpack_public_path__ + "static/media/banner-bg-ir-2024.c9b40888.jpg";